import visaLogo from "@assets/visa-logo.png";

interface PrimeseatLogoProps {
  className?: string;
}

const PrimeseatLogo = ({ className = "" }: PrimeseatLogoProps) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img
        src={visaLogo}
        alt="Visa"
        className="h-[0.9rem] w-auto object-contain mr-2.5"
      />
      <span className="font-montserrat font-extrabold text-primeseat-blue tracking-[0.2em] uppercase text-xs whitespace-nowrap">
        Dining Collection
      </span>
    </div>
  );
};

export default PrimeseatLogo;
